import { type FC } from 'react';
import { Link } from 'react-router';
import { Button, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { createPayoutCascadesUrl } from '~/entities/payout';

interface CascadeGroupEditorHeaderProps {
    isNew: boolean;
    groupId?: string;
}

export const CascadeGroupEditorHeader: FC<CascadeGroupEditorHeaderProps> = ({ isNew, groupId }) => {
    return (
        <Paper
            p='md'
            radius='md'
            withBorder
        >
            <Stack gap={4}>
                <Button
                    component={Link}
                    to={createPayoutCascadesUrl('groups')}
                    variant='subtle'
                    size='xs'
                    w='fit-content'
                    leftSection={<IconArrowLeft size={16} />}
                >
                    К списку групп
                </Button>

                <Group
                    gap='xs'
                    align='center'
                >
                    <Title
                        order={2}
                        size='h3'
                    >
                        {isNew ? 'Новая группа' : 'Группа трейдеров'}
                    </Title>
                </Group>

                {!isNew && (
                    <Text
                        size='sm'
                        c='dimmed'
                    >
                        {groupId}
                    </Text>
                )}
            </Stack>
        </Paper>
    );
};
